import { Icon, MenuItem, PopoverMenu, Typography, useTheme } from '@themenu/design-system'
import type { FC } from 'react'
import { useIntl } from 'react-intl'

import { useLocale } from '../../contexts/LocaleContext'
import { ALL_LOCALES, isLocaleEnabled } from '../../i18n/locale-availability'
import { typographyLinkStyle } from './LegalLinkFooter'

// Language switcher for the sign-in / BR activation flows' footer.
export const LanguageSwitcher: FC = () => {
  const { formatMessage } = useIntl()
  const { locale, setLocale } = useLocale()
  const theme = useTheme()

  const enabledLocales = ALL_LOCALES.filter(isLocaleEnabled)
  const currentLabel = formatMessage({ id: `profile.language.${locale}` })
  const ariaLabel = formatMessage({ id: 'profile.field.language' })

  const trigger = (
    <Typography
      variant="callout"
      component="button"
      type="button"
      aria-label={ariaLabel}
      style={{ color: theme.colors.content.placeholder }}
      className={`${typographyLinkStyle()} cursor-pointer bg-transparent focus:outline-none focus-visible:shadow-[0_0_0_2px_theme(colors.content-default)] dark:focus-visible:shadow-[0_0_0_2px_theme(colors.content-default-dark)]`}
    >
      <Icon name="planet" size={12} className="mr-4 inline-block align-middle" />
      {currentLabel}
      <Icon name="chevron-down" size={12} className="ml-4 inline-block align-middle" />
    </Typography>
  )

  return (
    <PopoverMenu onAction={(key) => setLocale(String(key))} trigger={trigger}>
      {enabledLocales.map((code) => {
        const label = formatMessage({ id: `profile.language.${code}` })
        return (
          <MenuItem key={code} textValue={label}>
            <span style={{ fontWeight: code === locale ? 600 : 400 }}>{label}</span>
          </MenuItem>
        )
      })}
    </PopoverMenu>
  )
}
